// Cloudinary configuration
// Cloud name for your Cloudinary account
export const CLOUD_NAME = 'drpgaqusa';

// Build a Cloudinary image URL with automatic format and quality optimization
export const cloudinaryUrl = (publicId: string, options?: { width?: number; height?: number }) => {
  const transforms = ['f_auto', 'q_auto'];
  if (options?.width) transforms.push(`w_${options.width}`);
  if (options?.height) transforms.push(`h_${options.height}`);
  return `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/${transforms.join(',')}/${publicId}`;
};

// Category colors that cycle through the brand palette
const CATEGORY_COLORS = ['#912F40', '#702632', '#40434E'];

export const getCategoryColor = (index: number) =>
  CATEGORY_COLORS[index % CATEGORY_COLORS.length];

// =====================================================
// CAR TAGS CONFIGURATION
// =====================================================
// To add a new car to the gallery:
//   1. Upload photos to Cloudinary
//   2. Tag them all with a slug (e.g., "ford-torino")
//   3. Add an entry below with { tag: 'your-slug', title: 'DISPLAY NAME' }
//   4. The site will automatically fetch and display them
//
// To reorder cars, just move the entries around in this array.
// To remove a car, delete or comment out its entry.
// =====================================================
export interface CarTagConfig {
  tag: string;
  title: string;
}

export const carTags: CarTagConfig[] = [
  { tag: 'ford-torino', title: 'FORD TORINO' },
  { tag: 'black-chevelle', title: 'BLACK CHEVELLE' },
  { tag: 'blue-c10', title: 'BLUE C10 TRUCK' },
  { tag: 'baby-blue', title: 'BABY BLUE BUILD' },
  { tag: 'red-ford-motor', title: 'RED FORD MOTOR' },
  { tag: 'cream-chevelle', title: 'CREAM CHEVELLE' },
  { tag: 'green-chevelle', title: 'GREEN CHEVELLE' },
  { tag: 'lincoln', title: 'LINCOLN CLASSIC' },
  { tag: '48-chevy', title: '48 CHEVY' },
  { tag: 'red-monte-carlo', title: 'RED MONTE CARLO' },
  { tag: 'betty-lou', title: 'BETTY LOU' },
  { tag: 'blue-chevelle', title: 'BLUE CHEVELLE' },
  { tag: 'el-camino', title: 'EL CAMINO' },
  { tag: 'gmc-2500', title: 'GMC 2500' },
  { tag: 'white-camaro', title: 'WHITE CAMARO' },
  { tag: 'bluecar', title: 'BLUE CAR' },
  { tag: 'ford', title: 'FORD' },
];
